import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import type { EntityValidationRules } from "services/validationService";
import { startOfEDAZEshop } from "config";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SentEmailMessageSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  @observable
  @Type(() => DateRangeRequest)
  sentDate?: DateRangeRequest;

  /**
   * Charge email or null.
   */
  @observable
  emailAddress?: string;

  /**
   * Vehicle registration plate or null.
   */
  @observable
  licensePlate?: string;

  /**
   * Country ID.
   */
  @observable
  countryId?: string;

  /**
   * Order identifier (variable symbol) or null.
   */
  @observable
  orderIdent?: number;

  /**
   * Charge ID.
   */
  @observable
  chargeId?: string;

  /**
   * Charge order ID.
   */
  @observable
  chargeOrderId?: string;

  @observable
  _validSince?: Date;

  @observable
  _validUntil?: Date;

  /**
   * Official record ID or null.
   * @example
   * ABC-23456/2022
   */
  @observable
  officialRecordId?: string;
}

const customMessage = "oneOfAttributesIsRequired";

const requiredIfCondition = (entity: SentEmailMessageSearchRequest) =>
  !!(!entity.licensePlate && !entity.orderIdent && !entity.emailAddress && !entity.chargeOrderId && !entity.chargeId) ||
  !!(entity.countryId && !entity.licensePlate && !entity.orderIdent && !entity.chargeOrderId && !entity.chargeId);

export const SentEmailMessageRequestValidationRules: EntityValidationRules<SentEmailMessageSearchRequest> = {
  licensePlate: {
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
    isLicensePlate: {
      required: false,
    },
  },

  orderIdent: {
    range: { min: 1000000001, max: 9999999999, optional: true },
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
  },
  emailAddress: {
    isLength: {
      min: 3,
      optional: true,
    },
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
  },
  chargeOrderId: {
    isLength: {
      min: 36,
      max: 36,
      optional: true,
    },
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
  },
  chargeId: {
    isLength: {
      min: 36,
      max: 36,
      optional: true,
    },
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
  },
  _validSince: {
    isAfter: {
      condition: (entity: SentEmailMessageSearchRequest) => {
        if (entity._validSince) {
          const startDate = new Date(startOfEDAZEshop);
          startDate.setDate(startDate.getDate() - 1);
          return startDate;
        }
        return undefined;
      },
    },
    isBefore: {
      condition: (entity: SentEmailMessageSearchRequest) => {
        if (entity._validUntil) {
          const oneDayLaterDate = new Date(entity._validUntil);
          oneDayLaterDate.setDate(oneDayLaterDate.getDate() + 1);

          return oneDayLaterDate;
        }

        return undefined;
      },
    },
  },
  _validUntil: {
    isAfter: {
      condition: (entity: SentEmailMessageSearchRequest) => {
        if (entity._validSince) {
          const oneDayEarlierDate = new Date(entity._validSince);
          oneDayEarlierDate.setDate(oneDayEarlierDate.getDate() - 1);

          return oneDayEarlierDate;
        }
        return undefined;
      },
    },
    isBefore: {
      condition: (entity: SentEmailMessageSearchRequest) => {
        if (entity._validUntil) {
          const future = new Date();
          future.setDate(future.getDate());

          return future;
        }

        return undefined;
      },
    },
  },
};
